export default __webpack_public_path__ + "static/media/terms-of-service-consent-kr-5.18fee9ec.jpg";